/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Corporate Header menu item component styles
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';
import { LinkTextBlock } from '../../../common/LinkBlock/styled/LinkStyled';

export const CorporateHeaderMenuItemStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `tab-menu ${className}`,
    tabIndex: 0,
}))<IAttrStyled>`
    position: relative;
    height: 100%;
    padding: 0 12px;

    &:first-child {
        padding-left: 0;
    }

    &.selected {
        outline: none;

        .tab-menu__link:before {
            display: block;
        }
    }

    &.isHover,
    &:hover {
        .tab-menu__drop-down,
        .tab-menu__link:before {
            display: block;
        }

        .tab-menu__link-arrow {
            transition: transform 200ms linear;
            transform: rotate(180deg);
        }
    }

    .tab-menu__link-arrow {
        transition: transform 300ms linear;
    }

    .tab-menu__link,
    .tab-menu__link .arrow-tooltip__text,
    .tab-menu__link a {
        display: flex;
        height: 100%;
        align-items: center;
        ${fonts.textMainBold};
    }

    .tab-menu__link {
        position: relative;
        cursor: pointer;
        border: none;

        &:before {
            content: ' ';
            position: absolute;
            bottom: 0;
            left: 50%;
            display: none;
            transform: translateX(-50%);
            width: 100%;
            border-bottom: 2px solid ${colors.borderColorNormal};
            background-color: ${colors.backgroundColorNormal};
        }
    }

    .tab-menu__drop-down {
        position: absolute;
        z-index: 4;
        left: -12px;
        display: none;
        min-width: calc(100% + 24px);
        padding: 16px 0;
        box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2);
        background-color: ${colors.backgroundColorWhite};

        .drop-down__link {
            white-space: nowrap;
            display: block;
            padding: 8px 24px;
            outline: none;
            &:hover, &:focus {
                ${LinkTextBlock} {
                    border-bottom: 1px solid ${colors.linkDefaultColorHover};
                }
            }
        }
    }
`;

